export default __webpack_public_path__ + "static/media/js.6af19dc3.svg";